import { PackageConfiguration } from '../interfaces/PackageConfiguration';

export default class Configuration {
  private static config: PackageConfiguration = {
    apiRoot: process.env.REACT_APP_PREFERENCES_MOCK_API === 'true' ? '/api' : process.env.REACT_APP_PREFERENCES_API_ROOT,
  };

  public static Current(): PackageConfiguration { return Configuration.config; }
}
